define(["require", "exports", "../../core/bootstrap/BootstrapBus"], function (require, exports, BootstrapBus_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BootstrapSkeleton = void 0;
    var BootstrapSkeleton = (function () {
        function BootstrapSkeleton() {
        }
        BootstrapSkeleton.prototype.monitor = function () {
            BootstrapBus_1.busEvent.$on(BootstrapBus_1.EventBusEnum.APPS_THEME_READY, this.onThemeReady.bind(this));
        };
        BootstrapSkeleton.prototype.onThemeReady = function (e) {
            try {
                var box = document.getElementById('skeleton');
                if (box) {
                    box.remove();
                }
            }
            catch (error) {
                console.log('Remoe dom error', error);
            }
        };
        return BootstrapSkeleton;
    }());
    exports.BootstrapSkeleton = BootstrapSkeleton;
});
//# sourceMappingURL=BootstrapSkeleton.js.map